import React, { useCallback } from 'react';
import { StyleSheet } from 'react-native';
import TouchableBounce from 'utils/packages/TouchableBounce';
import Text from 'design-system/Text';
import { IconScan } from 'design-system/icons';
import { useAppSelector } from 'store/hooks';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { CardView, rem } from 'design-system';
import Squircle from 'design-system/Squircle';
import PayIcon from 'features/pay/icons/PayIcon';
import RequestIcon from 'features/pay/icons/RequestIcon';
import { useRemovePayTabExperience } from 'features/pay/hooks/useRemovePayTabExperience';
import IconTransfer from 'design-system/icons/IconTransfer';
import { selectFeatureFlag, selectIsValidGBAccount, selectNavigatorConfig, } from 'reducers/selectors';
import useColors from 'hooks/useColors';
import { isWeb } from '../../../../constants';
const AccountPaySectionWrapper = (props) => {
    const { showPayTab } = useAppSelector(selectNavigatorConfig);
    // the pay actions survive the pay tab's removal
    const removePayTabExperience = useRemovePayTabExperience();
    const accountPayActions = useAppSelector((store) => selectFeatureFlag(store, 'account_pay_actions')).value;
    const isSupported = useAppSelector((store) => selectIsValidGBAccount(store, props.account.id));
    if (isWeb ||
        (!showPayTab && !removePayTabExperience) ||
        !isSupported ||
        !accountPayActions)
        return null;
    return <AccountPaySection {...props}/>;
};
const AccountPaySection = ({ account: bankAccount }) => {
    const colors = useColors();
    const navigation = useMainStackNavigation();
    const onPressScan = useCallback(() => navigation.navigateDeprecated('QRCodeScreen', { bankAccount }), [bankAccount]);
    const onPressPay = useCallback(() => navigation.navigateDeprecated('PayRequestScreen', {
        flow: 'pay',
        bankAccount,
    }), [bankAccount]);
    const onPressRequest = useCallback(() => navigation.navigateDeprecated('PayRequestScreen', {
        flow: 'request',
        bankAccount,
    }), [bankAccount]);
    const onPressTransfer = useCallback(() => navigation.navigateDeprecated('Transfer', { from: bankAccount }), [bankAccount]);
    return (<CardView withPadding noMarginTop noMarginBottom style={styles.container}>
      <TouchableBounce onPress={onPressScan} style={styles.button}>
        <Squircle color={colors.background.dark}>
          <IconScan colorKey="brand"/>
        </Squircle>
        <Text Text-14>Scan</Text>
      </TouchableBounce>

      <TouchableBounce onPress={onPressPay} style={styles.button}>
        <Squircle color={colors.background.dark}>
          <PayIcon colorKey="statusNegative"/>
        </Squircle>
        <Text Text-14>Pay</Text>
      </TouchableBounce>

      <TouchableBounce onPress={onPressRequest} style={styles.button}>
        <Squircle color={colors.background.dark}>
          <RequestIcon colorKey="statusPositive"/>
        </Squircle>
        <Text Text-14>Request</Text>
      </TouchableBounce>

      <TouchableBounce onPress={onPressTransfer} style={styles.button}>
        <Squircle color={colors.background.dark}>
          <IconTransfer colorKey="brand"/>
        </Squircle>
        <Text Text-14>Transfer</Text>
      </TouchableBounce>
    </CardView>);
};
const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
    },
    button: {
        paddingVertical: rem(1.5),
        alignItems: 'center',
        flex: 1,
        gap: rem(8),
    },
});
export default AccountPaySectionWrapper;
